import type { Cin7TaxComponent } from "@/api/dtos";
import type { TaxComponent } from "@/api/tax/_models/Tax";

export const toTaxComponentFromCin7TaxComponent = (
  c: Cin7TaxComponent,
): TaxComponent => {
  return {
    id: c.ID ?? null,
    name: c.Name,
    percent: Number(c.Percent),
    accountCode: c.AccountCode,
    compound: c.Compound === "1",
    order: Number(c.ComponentOrder),
  };
};

/** IDs are server-assigned, so they're omitted from the create payload. */
export const toCin7TaxComponentFromTaxComponent = (
  c: TaxComponent,
): Cin7TaxComponent => {
  return {
    Name: c.name,
    Percent: c.percent.toFixed(10),
    AccountCode: c.accountCode,
    Compound: c.compound ? "1" : "0",
    ComponentOrder: String(c.order),
  };
};
